<template>
    <div>
        <div class="white-box">
            <b-overlay :show="budgetDownloadLoading" no-center>
                <template #overlay>
                    <div class="loading-overlay">
                        <b-spinner></b-spinner>
                        <p style="text-align: center; margin-bottom: 5px; margin-top: 15px; font-size: 15px; color: #777e90;">Te rugăm să aștepți descărcarea documentului.</p>
                    </div>
                </template>
                <div class="data-group">
                    <M3FormTitle title="Bugetul proiectului tău" :checked="completed"></M3FormTitle>
                    <div class="adauga-asociat mb-5">
                        <div>
                            <p class="title"><strong>Super bugetul tău, simplu, intuitiv, Smis®</strong></p>
                            <p class="title-small">Te rugăm să analizezi cu atenție atenționările</p>
                        </div>
                        <div class="buttons-download">
                            <p class="add-button" @click="downloadBudget('xlsx')">
                                <img src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="exel_icon" >
                                Descarcă bugetul XLSX
                            </p>
                            <p class="add-button" @click="downloadBudget('pdf')">
                                <img src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download_icon" alt="pdf_icon" >
                                Descarcă bugetul PDF
                            </p>
                        </div>
                    </div>
                    <div class="item gray">
                        <div class="flex align-center">
                            <span class="title">BUGETUL TOTAL AL PROIECTULUI TĂU</span>
                            <img v-if="!completed" src="@/assets/images/M3/M3Sketch/danger-red.png" class="danger-red">
                        </div>
                        <div>
                            <span class="green-sum">{{ formatPrice(statistics.total.RON) }} lei</span>
                            <span class="sum">{{ formatPrice(statistics.total.EUR) }} €</span>
                        </div>
                    </div>
                    <div class="item gray mt-4">
                        <apexchart type="donut" width="380" :options="chartOptions" :series="series"></apexchart>
                        <div class="chart-info">
                            <div class="info">
                                <div class="left-info">
                                    <p class="green-text">Valoarea ajutorului nerambursabil</p>
                                    <p><strong>{{ formatPrice(statistics.nerambursabil.EUR) }} €</strong></p>
                                    <p>{{ formatPrice(statistics.nerambursabil.RON) }} lei</p>
                                </div>
                                <div :class="rightFrameOpen ? 'openedRightInfo' : 'right-info'">
                                    <span class="green-text">{{ chartOptions.dataLabels.formatter(series[0]) }}</span>
                                </div>
                            </div>
                            <div class="info">
                                <div class="left-info">
                                    <p class="purple-text">Valoarea cofinanțării eligibile</p>
                                    <p><strong>{{ formatPrice(statistics.cofinantare_eligibila.EUR) }} €</strong></p>
                                    <p>{{ formatPrice(statistics.cofinantare_eligibila.RON) }} lei</p>
                                </div>
                                <div :class="rightFrameOpen ? 'openedRightInfo' : 'right-info'">
                                    <span class="purple-text">{{ chartOptions.dataLabels.formatter(series[1]) }}</span>
                                </div>
                            </div>
                            <div class="info">
                                <div class="left-info">
                                    <p class="red-text">Valoarea cheltuielilor neeligibile</p>
                                    <p><strong>{{ formatPrice(statistics.cheltuieli_neeligibile.EUR) }} €</strong></p>
                                    <p>{{ formatPrice(statistics.cheltuieli_neeligibile.RON) }} lei</p>
                                </div>
                                <div :class="rightFrameOpen ? 'openedRightInfo' : 'right-info'">
                                    <span class="red-text">{{ chartOptions.dataLabels.formatter(series[2]) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="completed" class="item-green mt-4">
                        <p class="title">Nu există depășiri ale limitelor impuse prin Ghidul Solicitantului. Bugetul este întocmit corect.</p>
                    </div>
                    <div v-else class="item-red mt-4">
                        <p class="title">Atenție! Bugetul conține următoarele depășiri ale limitelor impuse prin ghid:</p>
                        <p v-if="statistics.cheltuieli_constructii > 50" class="title-small flex align-center">
                            <img src="@/assets/images/M3/M3Sketch/warn.png" alt="" class="mr-2">
                            Valoarea cheltuielilor pentru (1.1) modernizarea spațiilor de producție/servicii nu poate depăși 50% din valoarea proiectului - criteriul nu este îndeplinit
                        </p>
                        <p v-if="statistics.active_necorporale > 20" class="title-small flex align-center">
                            <img src="@/assets/images/M3/M3Sketch/warn.png" alt="" class="mr-2">
                            Valoarea eligibilă a activelor necorporale (3.2) nu poate depăși 20% din valoarea eligibilă a activelor corporale (3.1.1. + 3.1.2. + 3.1.3.) ce fac obiectul proiectului - criteriul nu este îndeplinit
                        </p>
                        <p v-if="statistics.cheltuieli_consultanta > 10" class="title-small flex align-center">
                            <img src="@/assets/images/M3/M3Sketch/warn.png" alt="" class="mr-2">
                            Cheltuielile de consultanță (2.1. + 2.2. + 2.3.) pentru pregătirea și implementarea proiectului se vor încadra în limita a 10% din valoarea eligibilă a proiectului - criteriul nu este îndeplinit
                        </p>
                        <p v-if="statistics.nerambursabil.EUR < 50000 || statistics.nerambursabil.EUR > statistics.max_budget" class="title-small flex align-center">
                            <img src="@/assets/images/M3/M3Sketch/warn.png" alt="" class="mr-2">
                            Valorea minimă a ajutorului (finanțării publice nerambursabile) este cuprinsă între 50.000 € și {{ formatPrice(statistics.max_budget ) }} € - criteriul nu este îndeplinit
                        </p>
                    </div>
                    <div class="item gray margin-top">
                        <div class="flex align-center">
                            <span class="title">VALOAREA ELIGIBILĂ A PROIECTULUI</span>
                            <img v-if="!completed" src="@/assets/images/M3/M3Sketch/danger-red.png" class="danger-red">
                        </div>
                        <div>
                            <span class="green-sum">{{ formatPrice(statistics.total_eligibil_proiect.RON) }} lei</span>
                            <span class="sum">{{ formatPrice(statistics.total_eligibil_proiect.EUR) }} €</span>
                        </div>
                    </div>
                    <div class="item gray mt-4">
                        <apexchart type="donut" width="380" :options="chartOptions" :series="series2"></apexchart>
                        <div class="chart-info">
                            <div class="info">
                                <div class="left-info">
                                    <p class="green-text">Valoarea ajutorului nerambursabil</p>
                                    <p><strong>{{ formatPrice(statistics.nerambursabil.EUR) }} €</strong></p>
                                    <p>{{ formatPrice(statistics.nerambursabil.RON) }} lei</p>
                                </div>
                                <div :class="rightFrameOpen ? 'openedRightInfo' : 'right-info'">
                                    <span class="green-text">{{ statistics.nerambursabil.procent.toFixed(2) }}%</span>
                                </div>
                            </div>
                            <div class="info">
                                <div class="left-info">
                                    <p class="purple-text">Valoarea cofinanțării eligibile</p>
                                    <p><strong>{{ formatPrice(statistics.cofinantare_eligibila.EUR) }} €</strong></p>
                                    <p>{{ formatPrice(statistics.cofinantare_eligibila.RON) }} lei</p>
                                </div>
                                <div :class="rightFrameOpen ? 'openedRightInfo' : 'right-info'">
                                    <span class="purple-text">{{ statistics.cofinantare_eligibila.procent.toFixed(2) }}%</span>
                                </div>
                            </div>
                            <div class="info business-details">
                                <p class="business-name">{{ statistics.nume_companie }}</p>
                                <p>Categorie: <span class="black">{{ statistics.tip_imm ? (statistics.tip_imm).toUpperCase() : '' }}</span></p>
                                <p>Valoare procent cofinanțare: <span class="black">{{ statistics.cofinantare_eligibila.procent }}%</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="item gray margin-top">
                        <div class="flex align-center">
                            <span class="title">Respectarea plafoanelor maxime impuse prin ghidul solicitantului</span>
                        </div>
                    </div>
                    <div class="mini-item gray budgetCustom">
                        <p class="title">Bugetul <strong>minim</strong> / <strong>maxim</strong></p>
                        <apexchart type="rangeBar" width="500" height="100" :options="budgetChartOptions" :series="budgetSeries"></apexchart>
                        <img v-if="statistics.nerambursabil.EUR < 50000 || statistics.nerambursabil.EUR > statistics.max_budget" src="@/assets/images/M3/M3Sketch/danger-red.png">
                        <p :class="{'title': true, 'red-text': statistics.nerambursabil.EUR < 50000 || statistics.nerambursabil.EUR > statistics.max_budget, 'green-text': statistics.nerambursabil.EUR >= 50000 && statistics.nerambursabil.EUR <= statistics.max_budget}">Valorea ajutorului nerambursabil<br><br>Minim 50.000€<br>Maxim {{ formatPrice(statistics.max_budget) }}€</p>
                    </div>
                    <div class="flex space-between gap15">
                        <div class="mini-item gray">
                            <p class="title">Valoarea cheltuielilor pentru <strong>Modernizarea spațiilor de producție/servicii</strong></p>
                            <div class="chart-block">
                                <div :class="{'chart chart-slim x-20': true, 'red-chart': statistics.cheltuieli_constructii > 50}" :style="{'--value': statistics.cheltuieli_constructii + '%'}">
                                    <p>{{ Number.isInteger(statistics.cheltuieli_constructii) ? statistics.cheltuieli_constructii : statistics.cheltuieli_constructii.toFixed(2) }}%</p>
                                </div>
                            </div>
                            <img v-if="statistics.cheltuieli_constructii > 50" src="@/assets/images/M3/M3Sketch/danger-red.png">
                            <p :class="{'title': true, 'red-text': statistics.cheltuieli_constructii > 50, 'green-text': statistics.cheltuieli_constructii <= 50}">Valoarea cheltuielilor pentru (1.1) modernizarea spațiilor de producție/servicii nu poate depăși 50% din valoarea proiectului - <strong>criteriul {{ statistics.cheltuieli_constructii > 50 ? 'nu' : '' }} este îndeplinit</strong></p>
                        </div>
                        <div class="mini-item gray">
                            <p class="title">Valoarea eligibilă a <strong>activelor necorporale</strong></p>
                            <div class="chart-block">
                                <div :class="{'chart chart-slim x-20': true, 'red-chart': statistics.active_necorporale > 20}" :style="{'--value': statistics.active_necorporale + '%'}">
                                    <p>{{ Number.isInteger(statistics.active_necorporale) ? statistics.active_necorporale : statistics.active_necorporale.toFixed(2) }}%</p>
                                </div>
                            </div>
                            <img v-if="statistics.active_necorporale > 20" src="@/assets/images/M3/M3Sketch/danger-red.png">
                            <p :class="{'title': true, 'red-text': statistics.active_necorporale > 20, 'green-text': statistics.active_necorporale <= 20}">Valoarea eligibilă a activelor necorporale (3.2) nu poate depăși 20% din valoarea eligibilă a activelor corporale (3.1.1. + 3.1.2. + 3.1.3.) ce fac obiectul proiectului - <strong>criteriul {{ statistics.active_necorporale > 20 ? 'nu' : '' }} este îndeplinit</strong></p>
                        </div>
                        <div class="mini-item gray">
                            <p class="title">Cheltuielile de <strong>consultanță</strong></p>
                            <div class="chart-block">
                                <div :class="{'chart chart-slim x-20': true, 'red-chart': statistics.cheltuieli_consultanta > 10}" :style="{'--value': statistics.cheltuieli_consultanta + '%'}">
                                    <p>{{ Number.isInteger(statistics.cheltuieli_consultanta) ? statistics.cheltuieli_consultanta : statistics.cheltuieli_consultanta.toFixed(2) }}%</p>
                                </div>
                            </div>
                            <img v-if="statistics.cheltuieli_consultanta > 10" src="@/assets/images/M3/M3Sketch/danger-red.png">
                            <p :class="{'title': true, 'red-text': statistics.cheltuieli_consultanta > 10, 'green-text': statistics.cheltuieli_consultanta <= 10}">Cheltuielile de consultanță (2.1. + 2.2. + 2.3.) pentru pregătirea și implementarea proiectului se vor încadra în limita a 10% din valoarea eligibilă a proiectului - <strong>criteriul {{ statistics.cheltuieli_consultanta > 10 ? 'nu' : '' }} este îndeplinit</strong></p>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import AdaugaAchizitiePopup from '../achizitii-cheltuieli/AdaugaAchizitiePopup'
    import { BForm, BFormInput, BIconPencilSquare, BIconTrash, BIconCheckCircleFill, BFormCheckbox, BIconPlusCircleFill, BIconDashCircleFill, BOverlay, BSpinner} from "bootstrap-vue";
    import Vue from 'vue'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import VueApexCharts from 'vue-apexcharts'
    import { BIconChevronUp } from 'bootstrap-vue'

    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)

    export default {
        components: {
            BForm,
            BFormInput,
            BIconPencilSquare,
            BIconTrash,
            BIconCheckCircleFill,
            BFormCheckbox,
            BIconPlusCircleFill,
            BIconDashCircleFill,
            M3FormTitle,
            AdaugaAchizitiePopup,
            LoadingSpinner,
            BIconChevronUp,
            BOverlay,
            BSpinner
        },
        props:{
            rightFrameOpen: null,
        },
        data() {
            return {
                completed: null,
                activeCompany: null,
                loading: true,
                budgetDownloadLoading: false,
                selected: 'lei',
                series: [0, 0, 0],
                statistics: {
                    nume_companie: "",
                    tip_imm: "",
                    max_budget: 0,
                    total: {
                        title: "",
                        RON: 0,
                        EUR: 0
                    },
                    total_eligibil_proiect: {
                        title: "",
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    cofinantare_eligibila: {
                        title: "",
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    cheltuieli_neeligibile: {
                        title: "",
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    nerambursabil: {
                        title: "",
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    equipment_percentage: {
                        title: "",
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    scadere_ca: 0,
                    investitii_mediu: 0,
                    caen_negativ: 0,
                    produs_inovativ: 0,
                    cresterea_productivitatii: 0,
                    cheltuieli_constructii: 0,
                    active_necorporale: 0,
                    cheltuieli_consultanta: 0
                },
                chartOptions: {
                    colors: ['#0cc2aa', '#7c59a3', '#ff7474'],
                    chart: {
                        type: 'donut',
                    },
                    labels: ['', '', ''],
                    dataLabels: {
                        formatter: function (val) {
                            return val.toFixed(2) + '%'
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'Montserrat, sans-serif',
                            colors: undefined
                        },
                        background: {
                            foreColor: '#fff',
                            padding: 4,
                            borderRadius: 2,
                            borderWidth: 1,
                            borderColor: '#fff',
                        },
                        dropShadow: {
                            enabled: false,
                        }
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                offset: 55,
                            },
                            startAngle: -30,
                            endAngle: 330,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                        }
                    }]
                },
                series2: [0, 0],
                chartOptions2: {
                    colors: ['#0cc2aa', '#7c59a3'],
                    chart: {
                        type: 'pie',
                    },
                    labels: ['', ''],
                    dataLabels: {
                        formatter: function (val) {
                            return val.toFixed(2) + '%'
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'Montserrat, sans-serif',
                            colors: undefined
                        },
                        background: {
                            foreColor: '#fff',
                            padding: 4,
                            borderRadius: 2,
                            borderWidth: 1,
                            borderColor: '#fff',
                        },
                        dropShadow: {
                            enabled: false,
                        }
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                offset: 45,
                            },
                            startAngle: -40,
                            endAngle: 320,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
                series3: [{
                    name: 'Inflation',
                    data: [5, 5, 6, 10]
                }],
                chartOptions3: {
                    colors: ['#f9c20d'],
                    chart: {
                        toolbar: {
                            show: false,
                        },
                        height: 135,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                position: 'bottom', // top, center, bottom
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return val;
                        },
                        offsetY: 0,
                        style: {
                            fontSize: '14px',
                            colors: ["#3b4369"]
                        }
                    },

                    xaxis: {
                        labels: {
                            show: true
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    yaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        labels: {
                            show: false,
                        }

                    },
                    states: {
                        normal: {
                            filter: {
                                type: 'none',
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                        active: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                    labels: {
                        show: false
                    },
                    tooltip: {
                        enabled: false,
                    }
                },
                series4: [{
                    name: 'Inflation',
                    data: [5, 5]
                }],
                chartOptions4: {
                    colors: ['#0cc2aa', '#7c59a3'],
                    chart: {
                        type: 'pie',
                    },
                    labels: ['', ''],
                    dataLabels: {
                        formatter: function (val) {
                            return val.toFixed(2) + '%'
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'Montserrat, sans-serif',
                            colors: undefined
                        },
                        background: {
                            foreColor: '#fff',
                            padding: 4,
                            borderRadius: 2,
                            borderWidth: 1,
                            borderColor: '#fff',
                        },
                        dropShadow: {
                            enabled: false,
                        }
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                offset: 45,
                            },
                            startAngle: -30,
                            endAngle: 330,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
                budgetSeries: [
                    {
                        name: 'Limite buget',
                        data: [
                            {
                                x: '',
                                y: [50000, 1000000],
                                goals: [
                                    {
                                        name: 'Valoare buget',
                                        value: 0,
                                        strokeWidth: 10,
                                        strokeHeight: 0,
                                        strokeLineCap: 'round',
                                        strokeColor: '#ff5555'
                                    }
                                ],
                                fillColor: '#0cc2aa'
                            },
                        ]
                    }
                ],
                budgetChartOptions: {
                    chart: {
                        height: 20,
                        type: 'rangeBar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                hideOverflowingLabels: true
                            },
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function() {
                            return ''
                        },

                    },
                    yaxis: {
                        show: false
                    },
                    xaxis: {
                        min: 0,
                        max: 1000000,
                        labels: {
                            formatter: function(val) {
                                let label = val
                                if (Number(label) >= 10000 && Number(label) < 1000000){
                                    label = Number(label) / 1000;
                                    label = label+'k';
                                }
                                if(Number(label) >= 1000000){
                                    label = Number(label) / 1000000;
                                    label = label+'M';
                                }
                                return label;
                            },
                        }
                    }
                },
            }
        },

        computed: {
            maxBudget() {
                return this.$store.getters['m3Sketch/maxBudget'];
            },
            checkComplete() {
                return this.statistics.cheltuieli_constructii;
            },
            getStatistics(){
                return this.$store.getters['m3Sketch/indicators'];
            }
        },
        watch: {
            getStatistics: {
                handler () {
                    if(this.getStatistics)
                        this.statistics = this.getStatistics;
                    this.getProjectStats();
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.activeCompany = JSON.parse(localStorage.getItem('currentM3Company')).id
            this.$store.dispatch('pageLoading/setLoading', false)
            this.$store.dispatch('m3Sketch/initializeIndicators')
            this.getProjectStats()
        },
        methods: {
            downloadBudget(type) {
                this.budgetDownloadLoading = true
                let link = ''
                let name = this.$store.getters['m3Sketch/m3Company'] ? this.$store.getters['m3Sketch/m3Company'].name : '-';
                if(type === 'pdf'){
                    link = api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +'/documents/budget_doc/xlsxToPdf'
                    name = 'buget_'+ name.replaceAll( /[^a-z0-9]+/ig, "_") +'.pdf'
                } else{
                    link = api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +'/documents/budget_doc/xlsx'
                    name = 'buget_'+ name.replaceAll( /[^a-z0-9]+/ig, "_") +'.xlsx'
                }
                axios({url: link, method: 'GET', responseType: 'blob'})
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', name);
                        document.body.appendChild(link);
                        link.click();
                        this.budgetDownloadLoading = false
                    })
                    .catch(() => {
                        this.$swal({
                            title: 'Document disponibil companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                            icon: 'info',
                            confirmButtonText: 'Cumpără licență',
                            showDenyButton: true,
                            denyButtonText: 'Anulează'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.$router.push({name: 'M3SketchCumparaLicenta'});
                            }
                        })
                        this.budgetDownloadLoading = false
                    })
            },
            getProjectStats() {
                if(this.activeCompany) {
                    if(this.statistics.active_necorporale < 20 && this.statistics.cheltuieli_constructii < 50 && this.statistics.cheltuieli_consultanta < 10 && this.statistics.nerambursabil.EUR >= 50000 && this.statistics.nerambursabil.EUR <= this.statistics.max_budget){
                        this.completed = true
                        this.$emit('budgetStatus', true)
                    }
                    else{
                        this.completed = false
                        this.$emit('budgetStatus', false)
                    }

                    let nerambursabil = parseFloat((this.statistics.nerambursabil.EUR * 100 / this.statistics.total.EUR ? this.statistics.nerambursabil.EUR * 100 / this.statistics.total.EUR : 0).toFixed(2));
                    let eligibil = parseFloat((this.statistics.cofinantare_eligibila.EUR * 100 / this.statistics.total.EUR ? this.statistics.cofinantare_eligibila.EUR * 100 / this.statistics.total.EUR : 0).toFixed(2));
                    let neeligibil = parseFloat((this.statistics.cheltuieli_neeligibile.procent == 0 ? 0 : 100 - nerambursabil - eligibil).toFixed(2));

                    this.series = [
                        nerambursabil,
                        eligibil,
                        neeligibil
                    ]

                    this.chartOptions.labels = [
                        this.statistics.nerambursabil.title,
                        this.statistics.cofinantare_eligibila.title,
                        this.statistics.cheltuieli_neeligibile.title
                    ]

                    this.series2 = [
                        this.statistics.nerambursabil.procent,
                        this.statistics.cofinantare_eligibila.procent
                    ]

                    this.chartOptions2.labels = [
                        this.statistics.nerambursabil.title,
                        this.statistics.cofinantare_eligibila.title
                    ]

                    this.series4 = [
                        100,
                        this.statistics.equipment_percentage.procent
                    ]

                    this.chartOptions4.labels = [
                        this.statistics.total.title,
                        'Procentul echipamentului tehnologic'
                    ]

                    this.budgetSeries = [
                        {
                            name: 'Limite buget',
                            data: [
                                {
                                    x: '',
                                    y: [50000, this.statistics.max_budget],
                                    goals: [
                                        {
                                            name: 'Valoare buget',
                                            value: this.statistics.nerambursabil.EUR,
                                            strokeWidth: 10,
                                            strokeHeight: 0,
                                            strokeLineCap: 'round',
                                            strokeColor: this.statistics.nerambursabil.EUR > 50000 && this.statistics.nerambursabil.EUR < this.statistics.max_budget ? '#846c89' : '#ff5555'
                                        }
                                    ],
                                    fillColor: '#0cc2aa'
                                },
                            ]
                        }
                    ]

                    this.loading = false
                    this.$forceUpdate();
                }
            },

            getBudgetChartPercentage() {
                return ((this.statistics.nerambursabil.EUR - 50000) * 100 / (this.statistics.max_budget - 50000)).toFixed(2);
            },

            kFormatter(number) {
                var SI_SYMBOL = ["", " k", " M"];
                var tier = Math.log10(Math.abs(number)) / 3 | 0;

                // if zero, we don't need a suffix
                if(tier == 0) return number;

                // get suffix and determine scale
                var suffix = SI_SYMBOL[tier];
                var scale = Math.pow(10, tier * 3);

                // scale the number
                var scaled = number / scale;

                // format number and add suffix
                return scaled.toFixed(1) + suffix;
            },

            formatPrice(price) {
                if(price) {
                    price = price.toString().replace('.', ',');
                    var pattern = /(-?\d+)(\d{3})/;
                    while (pattern.test(price))
                        price = price.replace(pattern, "$1.$2");
                }
                return price;
            },

            budgetIsFulfilled() {
                return this.statistics.nerambursabil.EUR >= 50000 && this.statistics.nerambursabil.EUR <= this.statistics.max_budget;
            },
        }
    }
</script>

<style scoped>
.buttons-download{
    display: inline-flex;
    width: 100%;
    max-width: 450px;
    gap: 20px;
}
.loading-overlay{
    margin-top: 10%;
    width: 100%;
    text-align: center;
}
.add-button{
    color: #fff;
    font-size: 12px;
}
.spinner {
    display: contents;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.margin-top{
    margin-top: 70px !important;
}
.data-group{
    margin: auto;
    width: 93%;
}
.flex{
    display: flex;
}
.adauga-asociat{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.adauga-asociat .title{
    font-size: 18px;
    color: #515679;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 10px;
}
.adauga-asociat .title-small{
    font-size: 15px;
    color: #515679;
    margin-top: -3px;
    font-weight: 300;
}
.item{
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}
.gap15{
    gap: 0 15px;
}
.mini-item{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px !important;
}
.mini-item .title{
    text-align: center;
    color: #253646;
    font-size: 14px;
    min-height: 63px;
    margin-bottom: 15px;
}
.mini-item:not(:first-child) .title:last-child{
    margin-top: 26px;
}
.space-between{
    justify-content: space-between;
}
.item-red{
    background: #ff7474;
}
.item-green, .item-red{
    margin-top: 10px;
    display: flex;
    padding: 10px 20px;
    flex-direction: column;
}
.item-green{
    background: #49cda8;
}
.item-red .title, .item-green .title{
    font-size: 15px;
    font-weight: 600;
    color: #fff;
}
.item-red .title-small, .item-green .title-small{
    font-size: 14px;
    font-weight: 500;
    color: #fff;
}
.gray{
    background: #f6f7f8;
    width: 100%;
    padding: 10px 30px;
    font-size: 14px;
}
.item .title{
    font-size: 16px;
    font-weight: 700;
    margin-right: 15px;
    color: #515679;
}
.sum{
    color: #515679;
    font-size: 24px;
    font-weight: 500;
}
.green-sum{
    color: #49cda8;
    font-size: 24px;
    margin-right: 15px;
    font-weight: 500;
}
.adauga-asociat{
    margin-top: -20px;
}
.add-button{
    margin-top: 0 !important;
}
.currency-selector{
    display: flex;
    align-items: center;
}
.lei, .euro{
    background: #49cda8;
    color: #fff;
    font-weight: 700;
    font-size: 23px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 30px;
    opacity: 0.5;
    cursor: pointer;
}
.lei{
    margin-right: 10px;
}
.selected{
    opacity: 1;
}
.chart-info{
    display: flex;
    flex-direction: column;
    width: 40%;
}
.info{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.info:not(:last-child){
    margin-bottom: 15px;
}
.right-info{
    width: 35%;
    min-width: 150px;
    margin-left: 10px;
    background: #fff;
    border: 1px solid #d5d7da;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 60px;
}
.right-info span{
    font-size: 38px;
    line-height: 1;
    font-weight: 200;
}
.openedRightInfo{
  width: 35%;
  background: #fff;
  border: 1px solid #d5d7da;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 60px;
}
.openedRightInfo span{
  font-size: 38px;
  line-height: 1;
  font-weight: 200;
}
.left-info{
    width: 60%;
}
.left-info p{
    text-align: right;
    font-size: 13px;
    margin: 0;
    line-height: 1.4;
    font-weight: 600;
}
.left-info p:not(:first-child){
    font-size: 19px;
    font-weight: inherit;
}
.green-text{
    color: #0cc2aa !important;
}
.purple-text{
    color: #7c59a3 !important;
}
.red-text{
    color: #ff7474 !important;
}
.red-chart{
    background-image: conic-gradient(#ff7474 var(--value), transparent var(--value)) !important;
}
.red-chart p{
    color: #ff7474 !important;
}
.chart {
    width: 65px;
    height: 65px;
}
.chart-slim {
    margin-right: 0px;
}
.chart-slim p{
    /* font-weight: 700 !important; */
    font-size: 14px !important;
    letter-spacing: -0.6px;
    color: #0cc2aa;
}
.chart-block{
    min-height: 80px;
}
.business-details{
    flex-direction: column;
    align-items: flex-end;
}
.business-name{
    font-size: 17px;
    color: #515679 !important;
    font-weight: 700;
}
.business-details p{
    text-align: right;
    color: #a99fb5;
    font-size: 14px;
    margin: 0;
}
.black{
    color: #515679 !important;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px !important;
    }
    .adauga-asociat{
        margin-top: 15px;
    }
}
@media screen and (max-width: 1441px){
  .margin-top {
    margin-top: 25px!important;
  }
}
@media (max-width: 1300px) {
  .openedRightInfo span{
    font-size: 22px;
    line-height: 1;
    font-weight: 200;
  }
  .budgetCustom{
    flex-direction: column!important;
    align-items: center!important;
  }
}
@media screen and (max-width: 1024px) {
    .item.gray {
        padding: 5px 0px;
    }
    .item .info .right-info {
        margin-right: 10px;
    }
    .item .chart-info {
        width:45%;
    }
    .item .chart-info .business-details {
        padding-right: 10px;
    }
}
.budgetCustom{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end
}
</style>
